import React from "react"
import { useKonva } from "../../context/KonvaContext"
import { getFields } from "../../helper"

const ModalField = (props) => {
    const { shapeType, handleInputChange, handleCalculateClick } = props
    const { sideDimensions } = useKonva()
    const fields = getFields(sideDimensions)

    return (
        <div className='wh_style'>
            <div className="inputWrapper">
                {fields[shapeType]?.map((field) => {
                    return (
                        <div key={field.name}>
                            <label>
                                {field.label}:
                            </label>
                            <input
                                type="number"
                                name={field.name}
                                value={field.value || ''}
                                onChange={handleInputChange}
                            />
                        </div>
                    )
                })}
            </div>
            <div>
                <button className='calculateBtn' onClick={handleCalculateClick}>Calculate</button>
            </div>
        </div>
    )
}

export default ModalField